import React from 'react';
import { Switch, Redirect, Route, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Import utlis
import LoadableMng from 'components/utilities/lodable_manager/LodableMng';

// Import components
import ProtectedUserLogged from 'components/hoc/ProtectedUserLogged';

// Import paths
import { TV_PATHS } from '../tv_routes/paths';

const Main = LoadableMng({
	func: () => import('components/views/Main')
});

const NotFound = LoadableMng({
	func: () => import('components/views/NotFound')
});

const Static = LoadableMng({
	func: () => import('components/templates/StaticContentTemplate')
});

const Login = LoadableMng({
	func: () => import('components/views/authentication/login/Login'),
	delay: 800
});

const Register = LoadableMng({
	func: () => import('components/views/authentication/register/Register')
});

const ResetPassword = LoadableMng({
	func: () =>
		import('components/views/authentication/reset_password/ResetPassword')
});

const EmailConfirmation = LoadableMng({
	func: () =>
		import(
			'components/views/authentication/email_confirmation/EmailConfirmation'
		)
});

const ContactSection = LoadableMng({
	func: () => import('components/views/root/contact/ContactSection')
});

const DocumentSection = LoadableMng({
	func: () => import('components/views/root/documents/Documents')
});

const Configurator = LoadableMng({
	func: () => import('components/views/configurator/Configurator')
});

const { MAIN } = TV_PATHS;

function RetailRoutes() {
	const { signOutLoading } = useSelector(({ auth }) => auth);
	const { pathname } = useLocation();
	const isOnLoginPage = pathname.includes('/logowanie');

	return (
		<Switch>
			{signOutLoading && !isOnLoginPage && <Redirect to={MAIN} />}
			<Route path="/strona/:alias" component={Static} />
			<Route path="/rejestracja" component={Register} />
			<Route path="/reset-hasla" component={ResetPassword} />
			<Route path="/potwierdzenie-email/:hash" component={EmailConfirmation} />
			<ProtectedUserLogged path="/logowanie" component={Login} />
			<Route path="/kontakt" component={ContactSection} />
			<Route path="/konfigurator" component={Configurator} />
			<Route path="/dokumenty" component={DocumentSection} />
			<Route path="/404" component={NotFound} />
			<Main />
			<Redirect to={MAIN} />
		</Switch>
	);
}

export default RetailRoutes;
